export interface VoiceDraftState {
  hasVoiceInput: boolean;
  pureVoiceValue: string | null;
}

export interface VoiceTranscriptAppendResult {
  value: string;
  state: VoiceDraftState;
}

export function appendTranscriptValue(existingValue: string, transcript: string): string {
  const existing = existingValue.trim();
  const spoken = transcript.trim();

  if (!spoken) {
    return existing;
  }

  return existing ? `${existing} ${spoken}` : spoken;
}

export function appendVoiceTranscript(
  existingValue: string,
  transcript: string,
  currentState: VoiceDraftState,
): VoiceTranscriptAppendResult {
  if (!transcript.trim()) {
    return { value: existingValue, state: currentState };
  }

  const existing = existingValue.trim();
  const nextValue = appendTranscriptValue(existing, transcript);
  const existingIsUneditedVoice = currentState.hasVoiceInput
    && currentState.pureVoiceValue === existing;
  const remainsPureVoice = existing.length === 0 || existingIsUneditedVoice;

  return {
    value: nextValue,
    state: {
      hasVoiceInput: true,
      pureVoiceValue: remainsPureVoice ? nextValue : null,
    },
  };
}
